import axios from "@/libs/api_ay.request";

// 获取ticket
export const getTicket = params => {
  return axios.request({
    url: "/MyCitsApi/ayv3/getTicket",
    data: params,
    method: "post"
  });
};
// 取门店
export const getCitsCompany = params => {
  return axios.request({
    url: "/MyCitsApi/ayv3/getCitsCompany",
    data: params,
    method: "post"
  });
};
// 取问答
export const getQuestion = params => {
  return axios.request({
    url: "/MyCitsApi/ayv3/getQuestion",
    data: {
      jsonparam: JSON.stringify(params)
    },
    method: "post"
  });
};
// 取问答详情
export const getQuestionDetail = params => {
  return axios.request({
    url: "/MyCitsApi/ayv3/getQuestionDetail",
    data: {
      jsonparam: JSON.stringify(params)
    },
    method: "post"
  });
};
// 问答详情浏览增加
export const questionBadd = params => {
  return axios.request({
    url: "/MyCitsApi/ayv3/questionBadd",
    data: {
      jsonparam: JSON.stringify(params)
    },
    method: "post"
  });
};
